





























































import Vue from 'vue'
import moment from 'moment-timezone'
import { mapMutations, mapActions, mapGetters } from 'vuex'
import { ModuleNames } from '@/store/module-names'
import { MutationNames, ActionNames, GetterNames } from '@/store/modules/unit-round-report/keys'

import { generatePdfFromHtml } from '@/utils/pdf-export'

import { ExportDialogs } from '@/constants/exports'
import { Timeouts } from '@/constants/timeouts'

import UnitRoundReportTable from '@/components/shift-and-round-reports/tables/UnitRoundReportTable.vue'
import IsGeneratingExportDialog from '@/components/dialog/IsGeneratingExportDialog.vue'

const enum ReportPeriods {
  TwoWeeks = '2 weeks',
  OneMonth = '1 month',
}

const enum NumericDays {
  TwoWeekPeriod = 13,
}

export default Vue.extend({
  components: {
    UnitRoundReportTable,
    IsGeneratingExportDialog,
  },

  data() {
    return {
      isFetchingReportData: false,
      chosenOneMonthPeriod: moment().format('YYYY-MM'),
      chosenTwoWeekPeriod: [
        moment().format('YYYY-MM-DD'),
        moment()
          .add(NumericDays.TwoWeekPeriod, 'days')
          .format('YYYY-MM-DD'),
      ],
      chosenReportPeriod: ReportPeriods.TwoWeeks,
      isGeneratingExport: false,
      isGeneratingExportDialogText: ExportDialogs.Pdf,
    }
  },
  computed: {
    formattedChosenDateRange() {
      if (this.isTwoWeekPeriod) {
        return `${moment(this.chosenTwoWeekPeriod[0]).format('MMMM Do')} - ${moment(this.chosenTwoWeekPeriod[1]).format(
          'MMMM Do'
        )}`
      } else {
        return moment(this.chosenOneMonthPeriod).format('MMMM, YYYY')
      }
    },
    shortFormattedTwoWeekDateRange() {
      return `${moment(this.chosenTwoWeekPeriod[0]).format('MMM Do')} - ${moment(this.chosenTwoWeekPeriod[1]).format(
        'MMM Do'
      )}`
    },
    reportRadioOptions() {
      return [
        {
          label: ReportPeriods.TwoWeeks,
          value: ReportPeriods.TwoWeeks,
        },
        {
          label: ReportPeriods.OneMonth,
          value: ReportPeriods.OneMonth,
        },
      ].map(opt => ({
        ...opt,
        isActive: this.chosenReportPeriod === opt.value,
      }))
    },
    isOneMonthPeriod() {
      return this.chosenReportPeriod === ReportPeriods.OneMonth
    },
    isTwoWeekPeriod() {
      return this.chosenReportPeriod === ReportPeriods.TwoWeeks
    },
    timestampsForGetRequest() {
      if (this.isOneMonthPeriod) {
        return {
          startTimestamp: moment(this.chosenOneMonthPeriod)
            .startOf('month')
            .valueOf(),
          endTimestamp: moment(this.chosenOneMonthPeriod)
            .endOf('month')
            .valueOf(),
        }
      } else {
        return {
          startTimestamp: moment(this.chosenTwoWeekPeriod[0])
            .startOf('day')
            .valueOf(),
          endTimestamp: moment(this.chosenTwoWeekPeriod[1])
            .endOf('day')
            .valueOf(),
        }
      }
    },
    unitRoundReport() {
      return this[GetterNames.unitRoundReport]
    },
    ...mapGetters(ModuleNames.unitRoundReport, [
      GetterNames.unitRoundReport,
      GetterNames.chosenOneMonthPeriod,
      GetterNames.chosenTwoWeekPeriod,
      GetterNames.chosenReportPeriod,
    ]),
  },
  watch: {
    chosenTwoWeekPeriod: {
      deep: true,
      handler() {
        this.chosenTwoWeekPeriod[1] = moment(this.chosenTwoWeekPeriod[0])
          .add(NumericDays.TwoWeekPeriod, 'days')
          .format('YYYY-MM-DD')
      },
    },
    timestampsForGetRequest: {
      deep: true,
      async handler() {
        this.setDateParamsInStore()
        await this.getUnitRoundReport()
      },
    },
  },
  async mounted() {
    if (!this[GetterNames.chosenReportPeriod]) {
      this.setDateParamsInStore()
      await this.getUnitRoundReport()
    } else {
      this.chosenReportPeriod = this[GetterNames.chosenReportPeriod]
      this.chosenOneMonthPeriod = this[GetterNames.chosenOneMonthPeriod]
      this.chosenTwoWeekPeriod = this[GetterNames.chosenTwoWeekPeriod].map(date => date)
    }
  },
  methods: {
    exportCsvForChosenDateRange() {
      console.log('export report')
    },
    async exportPdfForChosenDateRange() {
      this.isGeneratingExport = true
      await generatePdfFromHtml({
        filename: `Agartee Unit Round Report (${this.formattedChosenDateRange})`,
        source: this.$refs.unitRoundReportTable,
        //requires larger format (B4) due to width of table
        format: [9.8, 13.9],
        pagebreak: { avoid: 'tr' },
      })
      setTimeout(() => {
        this.isGeneratingExport = false
      }, Timeouts.OneSecond)
    },
    async getUnitRoundReport() {
      this.isFetchingReportData = true
      await this[ActionNames.getUnitRoundReportByTimestamps]({
        starttimestamp: this.timestampsForGetRequest.startTimestamp,
        endtimestamp: this.timestampsForGetRequest.endTimestamp,
      })
      this.isFetchingReportData = false
    },
    setDateParamsInStore() {
      this[MutationNames.updateChosenReportPeriod](this.chosenReportPeriod)
      this[MutationNames.updateChosenOneMonthPeriod](this.chosenOneMonthPeriod)
      this[MutationNames.updateChosenTwoWeekPeriod](this.chosenTwoWeekPeriod)
    },
    ...mapMutations(ModuleNames.unitRoundReport, [
      MutationNames.updateChosenOneMonthPeriod,
      MutationNames.updateChosenTwoWeekPeriod,
      MutationNames.updateChosenReportPeriod,
    ]),
    ...mapActions(ModuleNames.unitRoundReport, [ActionNames.getUnitRoundReportByTimestamps]),
  },
})
